export enum AdvertiserCampaignEnum {
  new = 'new',
  scheduled = 'scheduled',
  active = 'active',
  history = 'history'
}
